module.exports = __webpack_public_path__ + "img/P150T_weapon_32.c3418e48.png";